import React from "react"
import { FaSearch } from "react-icons/fa"

export function SearchTextbox({ value, onChange, placeholder }) {

    return (
        <div className="flex-grow-1">
            <div className="input-group search-group">
                <span  className="input-group-text text-muted-theme bg-theme-card" style={{ marginRight: "1px" }}>
                    <FaSearch />
                </span>
                <input
                    type="text"
                    className="form-control search-control py-2"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                />
            </div>
        </div>
    )
}

export default SearchTextbox